import React from 'react';
import { connect } from 'react-redux';
import scrollIntoView from 'scroll-into-view';
import Select from 'scy/Select';
import FormField from 'scy/FormField';
import PhoneInput from 'shared/components/phoneInput';
import * as checkoutActions from 'components/checkoutPage/actions';
import GiftBag from './GiftBag';
import { subsection } from '../styles.mod.scss';
import styles from './styles.mod.scss';
import { AccentH5, SmallAlt } from 'scy/text';
import margin from 'scy/margin.mod.scss';

const GIFT_OCCASION_OPTIONS = [
  'Birthday',
  'Anniversary',
  'Congratulations',
  'Thank You',
  'Just Because'
].map(str => ({ value: str, label: str }));

class GiftSection extends React.Component {
  componentDidUpdate() {
    if (this.props.giftRecipientError || this.props.giftMobileError) {
      const containerRect = this.container.getBoundingClientRect();
      if (containerRect && containerRect.top < 0)
        scrollIntoView(this.container);
    }
  }

  render() {
    return (
      <section className={subsection} ref={el => (this.container = el)}>
        <AccentH5
          uppercase
          tag="h1"
          marginClass={`${margin.top_0} ${margin.bottom_sm}`}
        >
          Gift Info
        </AccentH5>

        <FormField
          id="gift-info-recipient"
          labelText="Recipient Name"
          initialValue={this.props.giftRecipient}
          onChange={name => this.props.setGiftRecipient(name)}
          validate={name => this.props.validateRecipient(name)}
          error={this.props.giftRecipientError}
          autoFocus={!this.props.giftRecipient}
        />

        <fieldset className={styles.fieldset}>
          <SmallAlt tag="legend" className={styles.legend}>
            How would you like your recipient to be notified? They will recieve
            a link to your gift message and will be able to schedule their
            delivery.
          </SmallAlt>

          <PhoneInput
            id="gift-info-phone"
            labelText="Recipient Mobile"
            initialValue={this.props.giftMobile}
            onChange={number => this.props.setGiftMobile(number)}
            notValidMessage="Enter a valid mobile number"
            forwardValidator={this.props.forwardMobileValidator}
            error={this.props.giftMobileError}
            autoFocus={!!this.props.giftRecipient && !this.props.giftMobile}
          />

          <FormField
            id="gift-info-email"
            labelText="Recipient Email (optional)"
            initialValue={this.props.giftEmail}
            onChange={email => this.props.setGiftEmail(email)}
            validate={email => this.props.validateEmail(email)}
            error={this.props.giftEmailError}
            autoFocus={
              !!this.props.giftRecipient &&
              !!this.props.giftMobile &&
              !this.props.giftEmail
            }
          />

          <FormField
            textarea
            id="gift-info-note"
            labelText="Gift Note (optional)"
            initialValue={this.props.giftNote}
            onChange={note => this.props.setGiftNote(note)}
            autoFocus={
              !!this.props.giftRecipient &&
              !!this.props.giftMobile &&
              !!this.props.giftEmail &&
              !this.props.giftNote
            }
          />
        </fieldset>

        <Select
          instanceId="gift-occasion"
          name="gift-occasion"
          className={margin.bottom_xs}
          placeholder="What's the occasion? (optional)"
          options={GIFT_OCCASION_OPTIONS}
          value={this.props.giftOccasion}
          onChange={option =>
            this.props.setGiftOccasion((option && option.value) || '')
          }
          searchable={false}
        />

        <GiftBag />
      </section>
    );
  }
}

const ConnectedGiftSection = connect(
  state => ({
    giftRecipient: state.checkout.giftRecipient,
    giftEmail: state.checkout.giftEmail,
    giftMobile: state.checkout.giftMobile,
    giftNote: state.checkout.giftNote,
    giftOccasion: state.checkout.giftOccasion
  }),
  { ...checkoutActions }
)(GiftSection);

export default ConnectedGiftSection;
